import { getStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { is3SFeatureEnabled } from 'owa-mail-feature-flags';
import { SearchScopeKind } from 'owa-search-service';
import { getUserConfiguration } from 'owa-session-store';

export const enum SearchProvider {
    Substrate,
    ExecuteSearch,
    FindItem,
}

export default function getSearchProvider(): SearchProvider {
    const { staticSearchScope: scope } = getStore();
    const scopeKind = scope && scope.kind;

    if (getUserConfiguration().SessionSettings.IsExplicitLogon) {
        if (scopeKind === SearchScopeKind.ArchiveMailbox) {
            return SearchProvider.FindItem;
        } else {
            return SearchProvider.ExecuteSearch;
        }
    }

    /**
     * Key off of the staticSearchScope (as defined in the store) to determine
     * which search provider to use. This is determined by whether or not 3S
     * supports the given scenario.
     */
    if (scopeKind === SearchScopeKind.PrimaryMailbox) {
        return is3SFeatureEnabled('sea-substrateQuery')
            ? SearchProvider.Substrate
            : SearchProvider.ExecuteSearch;
    } else if (scopeKind === SearchScopeKind.ArchiveMailbox) {
        return is3SFeatureEnabled('sea-substrateQuery') &&
            isFeatureEnabled('sea-archive-mailbox-3S')
            ? SearchProvider.Substrate
            : SearchProvider.ExecuteSearch;
    } else if (scopeKind === SearchScopeKind.Group) {
        return SearchProvider.ExecuteSearch;
    } else if (scopeKind === SearchScopeKind.SharedFolders) {
        return SearchProvider.FindItem;
    }

    return null;
}
